import { buildModelManager } from "../builder.js";
const DefaultVectorStoreSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  createdById: true,
  description: true,
  expiresAt: true,
  fileCount: true,
  fileSizeBytes: true,
  isActive: true,
  lastModifiedById: true,
  lastSyncedAt: true,
  localFileIds: true,
  metadata: true,
  name: true,
  openaiFileIds: true,
  openaiVectorStoreId: true,
  status: true,
  syncError: true,
  syncStatus: true,
  tags: true,
  updatedAt: true
};
const modelApiIdentifier = "vectorStore";
const pluralModelApiIdentifier = "vectorStores";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultVectorStoreSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultVectorStoreSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultVectorStoreSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultVectorStoreSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultVectorStoreSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultVectorStoreSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultVectorStoreSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByOpenaiVectorStoreId",
    findByField: "openaiVectorStoreId",
    findByVariableName: "openaiVectorStoreId",
    modelApiIdentifier,
    defaultSelection: DefaultVectorStoreSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByOpenaiVectorStoreId",
    findByField: "openaiVectorStoreId",
    findByVariableName: "openaiVectorStoreId",
    modelApiIdentifier,
    defaultSelection: DefaultVectorStoreSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createVectorStore",
    operationReturnType: "CreateVectorStore",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      vectorStore: { required: false, type: "CreateVectorStoreInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultVectorStoreSelection
  },
  {
    type: "action",
    operationName: "bulkCreateVectorStores",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateVectorStoresInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultVectorStoreSelection
  },
  {
    type: "action",
    operationName: "updateVectorStore",
    operationReturnType: "UpdateVectorStore",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      vectorStore: { required: false, type: "UpdateVectorStoreInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultVectorStoreSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateVectorStores",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateVectorStoresInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultVectorStoreSelection
  },
  {
    type: "action",
    operationName: "deleteVectorStore",
    operationReturnType: "DeleteVectorStore",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteVectorStores",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertVectorStore",
    operationReturnType: "UpsertVectorStore",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      vectorStore: { required: false, type: "UpsertVectorStoreInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateVectorStoreResult": { hasReturnType: false },
      "... on UpdateVectorStoreResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultVectorStoreSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertVectorStores",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertVectorStoresInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultVectorStoreSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "vectorStoreGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const VectorStoreManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultVectorStoreSelection,
  operations
);
export {
  DefaultVectorStoreSelection,
  VectorStoreManager
};
//# sourceMappingURL=VectorStore.js.map
